// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"87b96019","498":"4436e78c","513":"2bd1df5d","703":"96f4baa3","787":"c2af877a"}[chunkId] + ".chunk.js";
};